import * as types from '../types/push_token';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var sendPushToken = actionCreator(types.SEND_PUSH_TOKEN);
export var successPushToken = actionCreator(types.SUCCESS_PUSH_TOKEN);
export var failurePushToken = actionCreator(types.FAILURE_PUSH_TOKEN);
export var setPushState = actionCreator(types.SET_PUSH_STATE);
export var requestPushState = actionCreator(types.REQUEST_PUSH_STATE);